import React from 'react';
import { Link } from 'react-router-dom';
import type { ResumoExecucao } from '../../src/lib/projetos/resumoExecucao';

interface ResumoExecucaoFaixaProps {
  resumo: ResumoExecucao;
}

/**
 * Faixa de KPIs do portfólio + alerta de projeto sem tarefa vinculada. Mesmo grid de métrica que
 * ProjetoDetailView já usa na aba Visão Geral (views/Projetos/ProjetoDetailView.tsx) — populado
 * agora com os números de todos os projetos em vez de um só.
 */
const ResumoExecucaoFaixa: React.FC<ResumoExecucaoFaixaProps> = ({ resumo }) => (
  <div className="mb-5">
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {[
        { rotulo: 'Projetos em execução', valor: resumo.projetosEmExecucao, alerta: false },
        { rotulo: 'Tarefas em aberto', valor: resumo.tarefasAbertas, alerta: false },
        { rotulo: 'Atrasadas', valor: resumo.tarefasAtrasadas, alerta: resumo.tarefasAtrasadas > 0 },
        { rotulo: 'Concluídas em 7 dias', valor: resumo.concluidasUltimos7Dias, alerta: false },
      ].map(kpi => (
        <div key={kpi.rotulo} className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-4">
          <p className="text-xs text-gray-500 dark:text-gray-400">{kpi.rotulo}</p>
          <p className={`text-2xl font-bold ${kpi.alerta ? 'text-rose-600 dark:text-rose-400' : 'text-gray-800 dark:text-white'}`}>
            {kpi.valor}
          </p>
        </div>
      ))}
    </div>

    {resumo.projetosSemTarefa.length > 0 && (
      <div className="mt-2 px-4 py-2 rounded-lg bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-500/30 text-xs text-amber-800 dark:text-amber-300">
        {resumo.projetosSemTarefa.length === 1
          ? '1 projeto ainda sem tarefa vinculada — '
          : `${resumo.projetosSemTarefa.length} projetos ainda sem tarefa vinculada — `}
        {resumo.projetosSemTarefa.map((p, i) => (
          <React.Fragment key={p.id}>
            {i > 0 && ', '}
            <Link to={`/projetos/${p.id}`} className="font-semibold underline hover:no-underline">
              {p.nome}
            </Link>
          </React.Fragment>
        ))}
      </div>
    )}
  </div>
);

export default ResumoExecucaoFaixa;
